import { render, staticRenderFns } from "./SimphonyDialog.vue?vue&type=template&id=a8f02d20"
import script from "./SimphonyDialog.vue?vue&type=script&lang=ts"
export * from "./SimphonyDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports